module.exports = __webpack_public_path__ + "assets/src/style/img/footer-iwcn.png?52f9b2fe4a83424adf44f2606a9df25a";